// Son de notification SYNTHÉTISÉ (Web Audio API) — aucun fichier asset à
// embarquer, donc sûr en APK (Capacitor webview) et sans requête réseau/CSP.
//
// UN SEUL son, et il ne sert QU'AU NIVEAU 1 (critique). L'activité normale est
// muette : le proprio a signalé le 28/07 que tout se ressemblait et que plus
// rien ne s'entendait. Si tout sonne, plus rien ne sonne.
//
// Le motif est le « double bip » choisi par le proprio : deux impulsions
// serrées à 1175 Hz avec une harmonique — c'est l'attaque très courte (2 ms)
// suivie d'une décroissance rapide qui rend le son percutant plutôt que doux.
// L'ancienne version culminait à 0,2 d'amplitude sur des sinus lents : trop
// discret sur un téléphone en poche.
//
// Le MÊME motif est embarqué en WAV dans l'APK (res/raw/ndoe_blip.wav) pour le
// canal Android `ndoe_critique`, qui prend le relais app FERMÉE. Garder les
// deux cohérents : on doit reconnaître le même son dans les deux situations.

let ctx = null;
let unlocked = false;

const FREQ = 1175;      // ré aigu — passe bien sur un petit haut-parleur
const AMPLITUDE = 0.55; // était 0.2 : inaudible dès qu'il y a du bruit autour
const HARMONIQUE = 0.5; // 2e harmonique : donne le côté clair, « pop »

function getCtx() {
  if (typeof window === 'undefined') return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) {
    try { ctx = new AC(); } catch (e) { ctx = null; }
  }
  return ctx;
}

// Politique « autoplay » mobile/APK : l'audio ne démarre qu'après un premier
// geste utilisateur. On déverrouille le contexte au 1er tap/clic/touche.
export function initNotifSound() {
  if (typeof window === 'undefined' || unlocked) return;
  const unlock = () => {
    const c = getCtx();
    if (c && c.state === 'suspended') c.resume().catch(() => {});
    unlocked = true;
    window.removeEventListener('pointerdown', unlock);
    window.removeEventListener('touchstart', unlock);
    window.removeEventListener('keydown', unlock);
  };
  window.addEventListener('pointerdown', unlock);
  window.addEventListener('touchstart', unlock);
  window.addEventListener('keydown', unlock);
}

// Une impulsion : fondamentale + harmonique, attaque franche, decay exponentiel.
function impulsion(c, depart, duree) {
  const t0 = c.currentTime + depart;
  const sortie = c.createGain();
  sortie.gain.setValueAtTime(0.0001, t0);
  sortie.gain.linearRampToValueAtTime(AMPLITUDE, t0 + 0.002); // l'attaque = le mordant
  sortie.gain.exponentialRampToValueAtTime(0.0001, t0 + duree);
  sortie.connect(c.destination);

  [[FREQ, 1], [FREQ * 2, HARMONIQUE]].forEach(([f, part]) => {
    const osc = c.createOscillator();
    const g = c.createGain();
    osc.type = 'sine';
    osc.frequency.value = f;
    g.gain.value = part / (1 + HARMONIQUE);
    osc.connect(g); g.connect(sortie);
    osc.start(t0);
    osc.stop(t0 + duree + 0.02);
  });
}

/**
 * Joue le son de notification. NE SONNE QUE POUR LE NIVEAU 1 (critique) —
 * l'appeler avec un niveau 2 est volontairement sans effet.
 */
export function playNotifSound(niveau) {
  if (Number(niveau) !== 1) return;
  try {
    const c = getCtx();
    if (!c) return;
    if (c.state === 'suspended') c.resume().catch(() => {});
    impulsion(c, 0, 0.13);      // 1er bip
    impulsion(c, 0.115, 0.20);  // 2e bip, très serré
    // Vibration courte-courte : double le signal quand le son est coupé.
    // Ignorée silencieusement là où l'API n'existe pas (desktop).
    if (typeof navigator !== 'undefined' && navigator.vibrate) navigator.vibrate([60, 50, 60]);
  } catch (e) { /* best-effort : le son ne doit jamais casser le flux */ }
}

export default playNotifSound;
